import MDBox from "@vendor/components/MDBox";
import { Grid } from "@mui/material";
import {
  AccessTimeFilled,
  InsertDriveFile,
  PersonAdd,
  Receipt,
  Topic,
  House,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import MenuCard from "@vendor/examples/Cards/MenuCards";
import { userContainPermission } from "@shared/utils/permission";
import { usePermission } from "@shared/hooks/usePermission";

export const DashboardItems = () => {
  const { t } = useTranslation();
  const { permissionList } = usePermission("Modulos Permitidos PC");
  const existPermission = (permission: string) => {
    return userContainPermission(permission, permissionList);
    // return true; // *** Usar esto para visualizar los módulos sin permisos ***
  };

  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        {existPermission("Vacantes") && (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
            <MDBox mb={1.5}>
              <Link to="/gestion-de-vacantes">
                <MenuCard icon={InsertDriveFile} title={t("managementVacancy")} />
              </Link>
            </MDBox>
          </Grid>
        )}
        {existPermission("Solicitudes") && (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
            <MDBox mb={1.5}>
              <Link to="/solicitudes">
                <MenuCard icon={Topic} title={t("managementApplication")} />
              </Link>
            </MDBox>
          </Grid>
        )}
        {existPermission("Carga de horas") && (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
            <MDBox mb={1.5}>
              <Link to="/gestion-de-horas">
                <MenuCard icon={AccessTimeFilled} title={t("managementHour")} />
              </Link>
            </MDBox>
          </Grid>
        )}
        {existPermission("Factura") && (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
            <MDBox mb={1.5}>
              <Link to="/gestion-de-facturas">
                <MenuCard icon={Receipt} title={t("managementInvoice")} />
              </Link>
            </MDBox>
          </Grid>
        )}
        {existPermission("Vacantes") && (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
            <MDBox mb={1.5}>
              <Link to="/referenciados">
                <MenuCard icon={PersonAdd} title={t("referenced")} />
              </Link>
            </MDBox>
          </Grid>
        )}
        {existPermission("Reservas") && (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
            <MDBox mb={1.5}>
              <Link to="/gestion-de-reservas">
                <MenuCard icon={House} title={t("managementReservation")} />
              </Link>
            </MDBox>
          </Grid>
        )}
      </Grid>
    </MDBox>
  );
};
